export const trackViewContent = eventDef => (action, prevState, nextState) => {
  const event = eventDef(action, prevState, nextState);
  const { type, content_name, content_type, content_ids, value, currency } = event;

  return {
    type,
    content_name,
    content_type,
    content_ids,
    value,
    currency
  }
}

export const trackLead = eventDef => (action, prevState, nextState) => {
  const event = eventDef(action, prevState, nextState);
  const { type, content_name, content_category, value, currency } = event;

  return {
    type,
    content_name,
    content_category,
    value,
    currency
  }
}

export const trackSearch = eventDef => (action, prevState, nextState) => {
  const event = eventDef(action, prevState, nextState);
  const { type, search_string } = event;

  if (search_string) {
    return {
      type,
      search_string
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/tracking/facebook-pixel/facebook-events.js